exports.components = {
  "component---packages-greenlight-core-src-pages-404-index-jsx": () => import("./../../../../../packages/greenlight-core/src/pages/404/index.jsx" /* webpackChunkName: "component---packages-greenlight-core-src-pages-404-index-jsx" */),
  "component---src-templates-home-index-jsx": () => import("./../../../src/templates/home/index.jsx" /* webpackChunkName: "component---src-templates-home-index-jsx" */)
}

